import { Form } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import QuickTimeSelect from "./QuickTimeSelect";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import moment from "moment";
import { QuickTimeSelectConfigMode } from "@/services/api/companySetting";

interface QuickTimeFieldProps {}

const QuickTimeField: React.FC<QuickTimeFieldProps> = function (props) {
    const orderManagementStore = useOrderManagementStore();

    function handleChange(configId: string) {
        const config = orderManagementStore.storage.quickTimeSelectConfigMapping.get(configId);

        if (!config) {
            orderManagementStore.table.form.setFieldsValue({ timeFrom: null, timeTo: null });

            return;
        }

        const { mode, value } = config;

        let timeFrom: string = null;
        let timeTo: string = null;

        if (mode === QuickTimeSelectConfigMode.HOURS_AGO) {
            timeTo = moment().subtract(value, "hours")?.format("YYYY-MM-DD HH:mm:ss");
        } else if (mode === QuickTimeSelectConfigMode.RECENT_HOURS) {
            timeFrom = moment().subtract(value, "hours")?.format("YYYY-MM-DD HH:mm:ss");
            timeTo = moment()?.format("YYYY-MM-DD HH:mm:ss");
        } else if (mode === QuickTimeSelectConfigMode.RECENT_DAYS) {
            timeFrom = moment().subtract(value, "days")?.format("YYYY-MM-DD HH:mm:ss");
            timeTo = moment()?.format("YYYY-MM-DD HH:mm:ss");
        }

        orderManagementStore.table.form.setFieldsValue({ timeFrom, timeTo });
    }

    return (
        <Form.Item noStyle name="quickTimeSelectConfigId">
            <QuickTimeSelect onChange={handleChange} />
        </Form.Item>
    );
};

export default observer(QuickTimeField);
